import { Injectable, Provider } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { IToastService, IToastServiceToken } from './toast-service.interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService implements IToastService {
  private toastAddSubject: ReplaySubject<ToastItem> = new ReplaySubject<ToastItem>();

  public toastItemAddSubject(): ReplaySubject<ToastItem> {
    return this.toastAddSubject;
  }

  public toastItemAdd(toastItem: ToastItem): void {
    this.toastAddSubject.next(toastItem);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ToastServiceProvider: Provider[] = [
  { provide: IToastServiceToken, useExisting: ToastService }
];
